import { render, staticRenderFns } from "./historyList.vue?vue&type=template&id=6bd88294&scoped=true&"
import script from "./historyList.vue?vue&type=script&lang=js&"
export * from "./historyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd88294",
  null
  
)

export default component.exports